import { Box, FormControl } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ReactElement, memo } from 'react'
import {
    IFilterValue,
    IKeyValuePair,
    ITableFilters,
} from '../../Entity/interfaces'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import { getShipmentStatusFiltersList } from '../../../utils/IntransitUtils'
import { Applications, IN_TRANSIT_TABS } from '../../../constants/constants'
import { setFilterList } from '../../../redux/slices/entitySlice'
import MultiSelectInput from '../../Common/MultiSelectInput'
import { getEntityTableFilters } from '../../../utils/EntityUtils'

const ShipmentStatusList = (): ReactElement => {
    const { t } = useTranslation()
    const allTableFilters = useAppSelector(
        (state) => state.entity.allTableFilters,
    )
    const intransitSlice = useAppSelector((state) => state.inTransit)
    const shipmentStatusAttributeId =
        intransitSlice?.inTransitSettings?.shipmentStatusAttributeId ??
        'shipmentStatus'
    const list: IKeyValuePair[] = getShipmentStatusFiltersList(intransitSlice)

    const templateId = intransitSlice.inTransitSettings.shipmentEntityTemplateId
    const applicationId: string = Applications.inTransit.id
    const tabIndex: string = IN_TRANSIT_TABS.MAP_VIEW.toString()
    const filterList: Record<string, IFilterValue> = getEntityTableFilters(
        allTableFilters,
        templateId,
        applicationId,
        tabIndex,
    )
    const dispatch = useAppDispatch()

    const value: string[] = filterList[shipmentStatusAttributeId]?.values || []

    const handleChange = (updatedSelections: string[]) => {
        const updatedAllTableFilters = allTableFilters.map((filter) => {
            if (
                filter.applicationId === applicationId &&
                filter.tabIndex === tabIndex &&
                filter.entityTemplateId === templateId
            ) {
                return {
                    ...filter,
                    allAttributesFilters: {
                        ...filter.allAttributesFilters,
                        [shipmentStatusAttributeId]: {
                            type: 'status',
                            values: updatedSelections,
                        },
                    },
                } as ITableFilters
            }
            return filter
        })
        dispatch(setFilterList(updatedAllTableFilters))
    }

    return (
        <Box sx={{ width: '100%' }}>
            <FormControl fullWidth size="small">
                <MultiSelectInput
                    id="entity-status-select"
                    label={t('shipmentStatusText')}
                    isLegend={true}
                    value={value}
                    onChange={(id: string, newValue: string[]) => {
                        handleChange(newValue)
                    }}
                    list={list.map((i) => {
                        return {
                            id: i.key,
                            name: t(i.value),
                        }
                    })}
                    displayInputLabel={false}
                    renderLabelInValue={true}
                    displayEmpty={true}
                />
            </FormControl>
        </Box>
    )
}

const MemoizedShipmentStatusList = memo(ShipmentStatusList)
MemoizedShipmentStatusList.displayName = 'ShipmentStatusList'
export default MemoizedShipmentStatusList
